import { db } from './../config/Fire';
import * as Constants from './../constants/nodes_database';

export const SET_DEFAULT_TIMETABLE_RESTAURANT_USER = 'SET_DEFAULT_TIMETABLE_RESTAURANT_USER';
export const SAVING_RESTAURANT = 'SAVING_RESTAURANT';
export const SAVED_RESTAURANT = 'SAVED_RESTAURANT';

const setDefaultTimetableRestaurantUser = payload => ({ type: SET_DEFAULT_TIMETABLE_RESTAURANT_USER, payload });
export const setSavingRestaurant = payload => ({ type: SAVING_RESTAURANT, payload });
export const setSavedRestaurant = payload => ({ type: SAVED_RESTAURANT, payload });

export const setDefaultTimetableToRestaurant = payload => {
    return dispatch => {
        var isSavingRestaurant = true;
        dispatch(setSavingRestaurant(isSavingRestaurant));
        const { id, defaultHours } = payload;
        if(id) {
            return db.ref(`${Constants.RESTAURANTS}/${id}/timetable`).update({
                default: defaultHours,
            })
            .then(() => {
                //console.log("getRestaurant: " + JSON.stringify(restaurant));
                dispatch(setDefaultTimetableRestaurantUser(payload));
                dispatch(setSavingRestaurant(isSavingRestaurant = false));
                var isSavedRestaurant = true;
                dispatch(setSavedRestaurant(isSavedRestaurant));
            })
            .catch(err => {
                console.log("not found save data");
                dispatch(setSavingRestaurant(isSavingRestaurant= false));
            });
        } else {
            console.log("id undefined: ");
                dispatch(setSavingRestaurant(isSavingRestaurant= false));
        }
    };
};